var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10938 7.01953H12.1755V14.0195H2.10938C1.55709 14.0195 1.10938 13.5718 1.10938 13.0195V7.01953Z",
    fill: "#201CE0",
    stroke: "black",
    strokeWidth: 0.351064
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20678 0C1.55755 0 1.03125 0.526303 1.03125 1.17553V13.367C1.03125 14.0162 1.55755 14.5426 2.20678 14.5426H22.9983C23.6476 14.5426 24.1739 14.0162 24.1739 13.367V1.17553C24.1739 0.526304 23.6476 0 22.9983 0H22.9978H12.2764H12.1009H2.20678ZM12.1009 0.351064H2.20678C1.75144 0.351064 1.38231 0.72019 1.38231 1.17553V13.367C1.38231 13.8224 1.75144 14.1915 2.20678 14.1915H22.9983C23.4537 14.1915 23.8228 13.8224 23.8228 13.367V7.1383H12.2764H12.1009V6.96277V0.351064ZM22.9978 0.351064H12.4519V6.78723H23.8222V1.17553C23.8222 0.720191 23.4531 0.351064 22.9978 0.351064Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeft);
export default __webpack_public_path__ + "static/media/bottom-left.fe50eb7a419f634922689a3d146d1b95.svg";
export { ForwardRef as ReactComponent };